import { CONTENT_STATUS, CONTENT_VISIBILITY } from "./contentConstants";

/** RTDB / legacy rows may use different casing; normalize before access checks. */
function normalizeDocStatus(raw) {
  const s = String(raw ?? "").trim().toLowerCase();
  return s === CONTENT_STATUS.PUBLISHED ? CONTENT_STATUS.PUBLISHED : CONTENT_STATUS.DRAFT;
}

function normalizeDocVisibility(raw) {
  const v = String(raw ?? "").trim().toLowerCase();
  if (v === CONTENT_VISIBILITY.PRIVATE) return CONTENT_VISIBILITY.PRIVATE;
  if (v === CONTENT_VISIBILITY.PREMIUM) return CONTENT_VISIBILITY.PREMIUM;
  return CONTENT_VISIBILITY.PUBLIC;
}

export const canViewContentItem = (item, user) => {
  if (!item) return false;

  const ownerId = item.authorId || item.createdBy || "";
  const isOwner = !!user?.uid && ownerId === user.uid;
  const status = normalizeDocStatus(item.status);
  const visibility = normalizeDocVisibility(item.visibility);

  const role = String(user?.role || "").toLowerCase();
  const isAdmin = role === "superadmin" || role === "admin";
  if (isAdmin) return true;
  if (status !== CONTENT_STATUS.PUBLISHED) return isOwner;
  if (visibility === CONTENT_VISIBILITY.PRIVATE || visibility === CONTENT_VISIBILITY.PREMIUM) return isOwner;
  return true;
};
